import {
  DATATABLE_ACTION,
  DATATABLE_ACTIONS,
  DATATABLE_COLUMNS,
  DATATABLE_DELETE,
  DATATABLE_FILTERS,
  DATATABLE_RESTORE
} from '../actions/datatable'
import apiCall from './call'
import fileDownload from '@/functions/fileDownload'

const actions = {
  [DATATABLE_COLUMNS]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: data.model + '/columns' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DATATABLE_FILTERS]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: data.model + '/filters' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DATATABLE_ACTIONS]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: data.model + '/actions' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DATATABLE_ACTION]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let postData = {
        'action': data.action,
        'selectedIds': data.selectedIds,
        ...data.input
      }

      apiCall({
        url: data.model + '/actions',
        data: postData,
        method: 'POST',
        responseType: data.handle === 'download' ? 'blob' : 'json'
      }).then(response => {
        if (data.handle === 'download') {
          fileDownload(response, data.fileName)
          return resolve(response)
        }

        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [DATATABLE_DELETE]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let deletedRows = { ids: data.selectedIds }
      if (data.force) {
        deletedRows.force = true
      }
      apiCall({ url: data.model, data: deletedRows, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DATATABLE_RESTORE]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      const selectedRows = { ids: data.selectedIds }
      apiCall({ url: data.model + '/restore', data: selectedRows, method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const state = {
  //
}

const getters = {
  //
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/datatable.js